module.exports = __webpack_public_path__ + "static/media/za.ae1a7acc.svg";